import {
  USER_PERSONAL_INFO_FAIL,
  USER_PERSONAL_INFO_REQUEST,
  USER_PERSONAL_INFO_SUCCESS,
  GET_USER_PERSONAL_INFO_FAIL,
  GET_USER_PERSONAL_INFO_REQUEST,
  GET_USER_PERSONAL_INFO_SUCCESS,
} from "../../types/user/personalInfoTypes";

export const userPersonalReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PERSONAL_INFO_REQUEST:
      return {
        ...state,
        personalLoading: true,
      };
    case USER_PERSONAL_INFO_SUCCESS:
      return {
        ...state,
        personalLoading: false,
        UserPersonalInfo: payload,
        personalError: "",
      };
    case USER_PERSONAL_INFO_FAIL:
      return {
        ...state,
        personalLoading: false,
        UserPersonalInfo: [],
        personalError: payload,
      };
    default:
      return state;
  }
};

export const getUserPersonalReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_USER_PERSONAL_INFO_REQUEST:
      return {
        ...state,
        getPersonalLoading: true,
      };
    case GET_USER_PERSONAL_INFO_SUCCESS:
      return {
        ...state,
        getPersonalLoading: false,
        personalUserInfo: payload,
        getPersonalError: "",
      };
    case GET_USER_PERSONAL_INFO_FAIL:
      return {
        ...state,
        getPersonalLoading: false,
        personalUserInfo: [],
        getPersonalError: payload,
      };
    default:
      return state;
  }
};
